module.exports = __webpack_public_path__ + "img/pkw-firestone.b773fd80.jpg";